<script setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { store } from "@/store";
import getFormFields from "@/utils/getFormFields";
import AppFormInput from "@/components/Form/AppFormInput";
import AppButton from "@/components/AppButton";
import AppCard from "@/components/AppCard";
import AppAlert from "@/components/AppAlert";
import AppGuestMenu from "@/components/AppGuestMenu";
import AppGuestShell from "@/components/AppGuestShell";
import AppGuestHeader from "@/components/AppGuestHeader";

// Api
import useApi from "@/composables/useApi";
const { user } = useApi();

const loading = ref(false);
const hasError = ref(false);
const router = useRouter();
const { t } = useI18n();

const menuOptions = [
  {
    icon: "uil uil-credit-card-search",
    label: t("login.quick"),
    route: "QuickPayment",
  },
  {
    icon: "uil uil-store",
    label: t("login.client"),
    route: "LeadForm",
  },
  {
    icon: "uil uil-phone",
    label: t("login.call"),
    url: "9986900610",
  },
];

onMounted(() => {
  store.APP_LOADING = false;
});

const login = async (e) => {
  try {
    console.log("Submit");
    if (loading.value) {
      return;
    }
    hasError.value = false;
    loading.value = true;
    const fields = getFormFields(e);
    // console.log(fields);
    const data = await user.signIn(fields.username, fields.password);
    // console.log(data);
    if (data) {
      console.log("success");
      // store.user = data;
      router.push({ name: "Home" });
    } else {
      hasError.value = true;
    }
  } catch (error) {
    hasError.value = true;
    console.error(error);
  } finally {
    loading.value = false;
    store.APP_LOADING = false;
  }
};
</script>
<template lang="pug">
AppGuestShell
  template(#menu)
    app-guest-menu.login__menu(:options="menuOptions")
  AppCard(padding="lg" elevated)
    AppGuestHeader(:title="$t('login.title')" :subtitle="$t('login.subtitle')")
    transition(name="alert")
      AppAlert.login__alert(:title="$t('login.error_title')" :subtitle="$t('login.error_subtitle')" v-if="hasError")
    form(@submit.prevent="login")
      AppFormInput(
        type="text"
        name="username"
        icon="uil uil-user"
        :label="$t('login.username')"
        :disabled="loading"
        required
      )
      AppFormInput(
        type="password"
        name="password"
        icon="uil uil-lock-alt"
        :label="$t('login.password')"
        :disabled="loading"
        required
      )
      .login__forgot
        router-link.guest-link(:to="{ name: 'ResetPass' }") {{ $t("userOptions.forgotPass") }}
      AppButton(:loading="loading" :disabled="loading" :label="$t('login.send')")
    .guest-divider
    router-link.guest-action(:to="{ name: 'NewUser' }")
      i.uil.uil-user-plus(aria-hidden="true")
      span {{ $t("userOptions.newUser") }}
</template>

<style lang="scss" scoped>
.login {
  &__menu {
    @apply mb-5;
  }

  &__alert {
    @apply mb-5;
  }

  &__forgot {
    @apply flex;
    @apply justify-end;
    @apply -mt-1;
    @apply mb-5;
  }
}

.alert-enter-active,
.alert-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.alert-enter-from,
.alert-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
